import { makeVar } from '@apollo/client'

import { SimCardType } from 'types/sim'

export const rvSimList = makeVar<SimCardType[]>([])
export const rvSelectedSim = makeVar<SimCardType>({} as SimCardType)

export const rvSelectedSimSite = makeVar('')
